import { render, staticRenderFns } from "./integratedAssistanceModule.vue?vue&type=template&id=02a48cd2&"
import script from "./integratedAssistanceModule.vue?vue&type=script&lang=js&"
export * from "./integratedAssistanceModule.vue?vue&type=script&lang=js&"
import style0 from "./integratedAssistanceModule.vue?vue&type=style&index=0&id=02a48cd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports